import { StarGlyph } from './icons'
import { toRoman } from '@lunary/app-core/roman'
import styles from './arch-card.module.css'

type ArchSize = 'xs' | 'sm' | 'md' | 'lg' | 'hero'

type Props = {
  number: number
  name: string
  size?: ArchSize
}

export function ArchCard({ number, name, size = 'md' }: Props) {
  const numeral = toRoman(number)
  const className = `${styles.arch} ${styles[size] ?? ''}`
  if (size === 'hero') {
    return (
      <figure className={className} aria-label={name}>
        <span className={styles.numeral}>{numeral}</span>
        <StarGlyph className={styles.glyph} />
        <figcaption className={styles.name}>{name}</figcaption>
      </figure>
    )
  }
  return (
    <div className={className} role="img" aria-label={`Карта ${name}, ${numeral}`}>
      <span className={styles.numeral}>{numeral}</span>
      <StarGlyph className={styles.glyph} />
    </div>
  )
}

export type { ArchSize }
